<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-1 pt-0 pt-md-5 pt-xl-2 pb-4 shadow-lg col-xs-12 col-lg-8"
>
  <div class="jumbotron-fluid col-12 col-md-6">
    <div class="container my-2 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h4
            class="rub-head4 text-info text-center font-weight-bold py-1"
          >
            Cluster
          </h4>
        </div>
      </div>
    </div>
    <div class="invest-card card-body mt-2 pt-3 mb-0 mx-auto pb-2 shadow-lg">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="form-group text-primary">
          <label
            for="stageClusterName"
            [ngClass]="fval.stageClusterName.valid ? 'text-info' : ''"
            >Cluster Name<i
              *ngIf="fval.stageClusterName.valid"
              class="material-icons"
              >check_circle</i
            ></label
          >
          <div class="input-group mb-0">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i
                  class="fas fa-tag text-primary mx-auto"
                  style="size: 50px"
                >
                </i>
              </div>
            </div>
            <input
              id="stageClusterName"
              type="text"
              formControlName="stageClusterName"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (fval.stageClusterName.touched ||
                    fval.stageClusterName.dirty) &&
                  fval.stageClusterName.errors
              }"
              autocomplete="off"
              placeholder="Enter Cluster Name"
            />
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.stageClusterName.touched || fval.stageClusterName.dirty) &&
              fval.stageClusterName.errors?.required
            "
          >
            The cluster name is required!
          </div>
        </div>
        <div class="form-group text-primary">
        <label
          for="station"
          [ngClass]="fval.station.valid? 'text-info' : ''"
        >Station<i *ngIf="fval.station.valid" class="material-icons">check_circle</i>
        </label>
        <div class="input-group mb-0">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i
                class="fas fa-gas-pump text-primary mx-auto"
                style="size: 50px"
              >
              </i>
            </div>
          </div>
          <select
            id="station"
            [ngClass]="{
              'is-invalid':
                (fval.station.touched || fval.station.dirty) &&
                fval.station.errors
            }"
            autocomplete="off"
            class="form-control"
            formControlName="station"
            placeholder="Select station"
          >
            <option class="place-holder-select" disabled hidden selected value="">Select Station Location</option>
            <option *ngFor="let station of stations" [value]="station.theStationLocationId">
              {{station.stationName.toUpperCase()}}
            </option>
          </select>
        </div>
        <div
          class="text-danger col"
          *ngIf="
                  (fval.station.touched || fval.station.dirty) &&
                  fval.station.errors?.required
                "
        >
          The station is required!
        </div>
      </div>

        <div class="d-flex mt-2 mb-3 pt-0 pb-3 mx-auto">
          <button
            type="submit"
            class="btn btn-info col-5 mx-auto"
            [disabled]="!userForm.valid"
          >
            Enroll
          </button>

          <ngx-spinner class="bg-info" size="medium" type="ball-scale-multiple">
            <p class="text-light">Please wait...</p>
          </ngx-spinner>

          <label class="col" *ngIf="errored" class="text-danger">
            <!-- <i class="material-icons">cancel</i> -->

            <ngx-alerts></ngx-alerts>
          </label>

          <label class="col" *ngIf="posted" class="text-info">
            <!-- <i class="material-icons">check_circle</i> -->
            <ngx-alerts></ngx-alerts>
          </label>

          <button
            type="button"
            class="btn btn-info col-5 mx-auto"
            (click)="revert()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
